import UspTile from 'components/Common/UspTile/UspTile'
import TextLink from 'LuxKit/TextLink'
import type { ValueSectionItem } from './ValuePropositionItems'

interface Props {
  item: ValueSectionItem
}

function HomepageValueUspTile({ item }: Props) {
  const action = item.link?.text
    ? <TextLink href={item.link.href} size="medium" weight="bold" target="_blank">
        {item.link.text}
    </TextLink>
    : undefined

  return <UspTile
    icon={item.icon}
    heading={item.heading}
    action={action}
  >
    {item.body}
  </UspTile>
}

export default HomepageValueUspTile
